// removed by extract-text-webpack-plugin
module.exports = {"table":"table-Xg3eO","tableActions":"tableActions-3hWHm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-container/table-container.less
 ** module id = 191
 ** module chunks = 0
 **/